module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28394",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9501",
      "ably-hubspot-js": "static-2.4543",
      "atom": "static-1.4894",
      "conversations-async-data": "static-2.7488",
      "conversations-error-reporting": "static-1.8701",
      "conversations-internal-pub-sub": "static-1.15790",
      "conversations-internal-schema": "static-1.12527",
      "conversations-message-history": "static-1.12100",
      "conversations-test-sdk": "static-1.10323",
      "conversations-visitor-experience-components": "static-1.21757",
      "head-dlb": "static-1.4841",
      "hs-promise-utils": "static-1.5418",
      "hs-test-utils": "static-1.7831",
      "hubspot-dlb": "static-2.1806",
      "HubStyleTokens": "static-2.11258",
      "I18n": "static-7.1577",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2842",
      "jasmine-runner": "static-1.6296",
      "quartz": "static-1.6767",
      "react-dlb": "static-1.73",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.61",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4299",
      "StyleGuideUI": "static-3.484",
      "transmute": "static-2.85",
      "urlinator": "static-1.4356",
      "usage-tracker": "static-1.7160",
      "usage-tracker-core": "static-1.7010",
      "usage-tracker-public": "static-1.6971",
      "viral-links-lib": "static-1.6861",
      "visitor-ui-component-library": "static-1.5959",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4634",
      "conversations-prop-types": "static-1.7277",
      "conversations-visitor-message-history": "static-1.20494",
      "cssUtils": "static-1.741",
      "enviro": "static-4.405",
      "flux-actions": "static-1.310",
      "foundations-components": "static-1.7571",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6044",
      "hubspot-url-utils": "static-1.3957",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9436",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.367",
      "raven": "static-3.5725",
      "react": "static-7.180",
      "react-aria": "static-1.62",
      "react-dom": "static-7.85",
      "react-redux": "static-7.67",
      "react-rhumb": "static-1.16476",
      "react-utils": "static-2.5198",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7969",
      "signup-constants": "static-1.18469",
      "styled-components": "static-2.85",
      "usage-tracker-multi": "static-1.5574",
      "visitor-ui-component-library-icons": "static-1.5770",
      "hs-promise-rejection-tracking": "static-1.5387",
      "raven-hubspot": "static-1.6032",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3252",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.82",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.78",
      "quartz-config": "static-1.545",
      "quartz-core": "static-1.5986",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4661",
      "foundations-theming": "static-1.4237",
      "UIComponents": "static-3.8205",
      "customer-data-email": "static-1.17712",
      "cv-backend-services": "static-1.1513",
      "immutable-less": "static-1.4479",
      "conversations-skeleton-state": "static-1.7073",
      "crm-events-viz-core": "static-1.32547",
      "customer-data-objects": "static-1.7473",
      "icons": "static-2.623",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4459",
      "ui-images": "static-2.1101",
      "HeadJS": "static-2.715",
      "framer-motion": "static-1.68",
      "hs-test-utils-bend-plugin": "static-1.2942",
      "msw": "static-1.39",
      "testing-library": "static-1.148",
      "i18n-data": "static-1.217",
      "moment-timezone": "static-5.79",
      "jasmine": "static-4.4151",
      "signup-ui-url-generator": "static-2.7858",
      "HubStyle": "static-2.11566",
      "quartz-i18n": "static-1.442",
      "sassPrefix": "static-1.152",
      "bend-plugin-foundations-components": "static-1.3840",
      "floating-ui": "static-1.52",
      "foundations-theming-specialty": "static-1.1953",
      "hs-story-utils": "static-1.9251",
      "react-virtualized": "static-2.95",
      "tanstack-table": "static-1.51",
      "trellis-assets": "static-1.1286",
      "ui-fonts": "static-1.520",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3760",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5577",
      "bender-build-tools": "static-1.2970",
      "dispatcher": "static-1.132",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.799",
      "hubspotter-http": "static-1.4501",
      "mobile-manifest-mixins": "static-1.488",
      "module-federation": "static-1.19",
      "quartz-auth": "static-1.442",
      "quartz-head": "static-1.432",
      "quartz-routing": "static-1.197",
      "quartz-test": "static-1.442",
      "quartz-tracking": "static-1.146",
      "usage-tracker-container": "static-1.7150",
      "bend-plugin-foundations-theming": "static-1.2720",
      "foundations-theming-base": "static-1.3222",
      "stylex": "static-1.28",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4476",
      "customer-data-ui-utilities": "static-1.9648",
      "FileManagerCore": "static-1.38469",
      "FileManagerLib": "static-1.38610",
      "hubspot-apollo-client": "static-1.4705",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.521",
      "timezone-utils": "static-2.5069",
      "ui-gdpr-components": "static-1.10172",
      "ts-schema": "static-1.3928",
      "ai-components-ui-library": "static-1.8411",
      "avatar-components": "static-1.2313",
      "content-assistance-lib": "static-1.7484",
      "crm-component-utils": "static-1.38526",
      "crm-display-components": "static-1.24276",
      "crm-fe-perf": "static-1.22730",
      "crm-links": "static-1.6091",
      "crm-message-bus": "static-1.42427",
      "crm-search-service-types": "static-1.978",
      "crm-source-interpretation-lib": "static-1.5154",
      "customer-data-communicator": "static-1.44980",
      "customer-data-filters-ui": "static-1.38982",
      "customer-data-objects-ui-components": "static-1.12833",
      "customer-data-properties": "static-1.50858",
      "customer-data-rte": "static-1.32500",
      "draft-plugins": "static-2.21349",
      "file-manager-components": "static-1.22970",
      "framework-data-schema-resolvers": "static-1.6697",
      "frontend-preferences-client": "static-1.7749",
      "hubspot-prosemirror": "static-1.17665",
      "object-comments-thread-lib": "static-1.10139",
      "reference-resolvers-lite": "static-1.7919",
      "ui-addon-upgrades": "static-9.17692",
      "universal-associations-select": "static-1.10815",
      "inbound-db-properties-service-client": "static-1.3698",
      "property-translator": "static-1.5235",
      "hub-http-shared-msw-handlers": "static-1.9529",
      "hubspotter-http-shared-msw-handlers": "static-1.9527",
      "react-router-dom": "static-5.26",
      "react-dnd-compat": "static-1.4445",
      "audio-components": "static-1.5647",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.36121",
      "foundations-components-legacy": "static-1.596",
      "immerable": "static-1.3979",
      "ui-universal-auth": "static-1.8733",
      "video-components": "static-1.12635",
      "video-data-lib": "static-1.34290",
      "video-embed": "static-1.35124",
      "hubspot-apollo-cache": "static-1.164",
      "chatspot-core": "static-1.20423",
      "chirp-fetch": "static-1.1707",
      "ContentUtils": "static-1.67687",
      "copilot-toolkit": "static-1.10591",
      "superstore": "static-1.4595",
      "ui-addon-video-player": "static-1.8521",
      "ui-coaching-tips": "static-1.28001",
      "card-properties-lib": "static-1.43586",
      "crm-actions": "static-1.6130",
      "crm-cards-data": "static-1.1261",
      "crm-cards-sdk": "static-1.42985",
      "customer-data-properties-shared-msw-handlers": "static-1.8856",
      "customer-data-property-utils": "static-1.7904",
      "customer-data-tracking": "static-1.6706",
      "inbound-db-meta-service-client": "static-1.3444",
      "framework-data-table": "static-2.11468",
      "location-customization-utils-lib": "static-1.8630",
      "calling-error-reporting": "static-1.31125",
      "calling-internal-common": "static-1.31119",
      "calling-usage-tracker": "static-1.6365",
      "crm_data": "static-4.91293",
      "customer-data-content": "static-1.26916",
      "draft-content-plugins": "static-1.27767",
      "draft-convert": "static-2.68",
      "draft-extend": "static-3.71",
      "draft-js": "static-5.73",
      "draft-signature-plugin": "static-1.23569",
      "EmailSignatureEditor": "static-1.23960",
      "hubspot-prosemirror-plugins": "static-1.17657",
      "integration-settings-components": "static-1.14865",
      "integrations-lib": "static-1.15494",
      "integrations-tracking-lib": "static-1.5413",
      "native-integrations-shared-strings": "static-1.7613",
      "nav-meta": "static-1.28980",
      "onboarding-scopes": "static-1.6287",
      "outreach-assistant-email-generation": "static-1.5822",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37373",
      "react-colorpicker": "static-2.10035",
      "reference-resolvers": "static-1.7986",
      "rich-text-lib": "static-1.19513",
      "sales-email-signature-service-client": "static-1.3668",
      "sequences-lib": "static-1.7725",
      "ui-addon-i18n": "static-1.10968",
      "ui-addon-iframeable": "static-1.8871",
      "ui-business-units-lib": "static-1.8854",
      "ui-shepherd-react": "static-3.9971",
      "user-context": "static-1.4924",
      "whatsapp-sending-lib": "static-1.4985",
      "customer-data-filters-ui-msw-helpers": "static-1.21417",
      "customer-data-reference-ui-components": "static-1.12971",
      "FormUrlGenerator": "static-2.4552",
      "framework-builder-read-service-client": "static-1.3857",
      "framework-data-schema-quick-fetch": "static-1.6602",
      "multi-account-reference-resolvers": "static-1.798",
      "onboarding-tours": "static-1.16299",
      "reporting-datasets-permissions-lib": "static-1.13123",
      "SharedI18nStrings": "static-1.180",
      "ui-addon-teams": "static-1.21274",
      "calling-global-api": "static-1.63753",
      "calling-lifecycle-internal": "static-1.65135",
      "calling-lifecycle-messages": "static-1.57429",
      "commerce-products-lib": "static-1.8923",
      "conditional-properties-service-client": "static-1.3647",
      "external-options-client-types": "static-1.4008",
      "google-libphonenumber": "static-1.34",
      "hs-entities": "static-1.504",
      "inbounddb-objects-service-types": "static-1.4071",
      "meetings-icalendar-utils-lib": "static-1.457",
      "multi-currency-client-types": "static-1.3540",
      "object-builder-ui-client": "static-1.48065",
      "pipeline-validation-client-types": "static-1.3812",
      "property-value-citations": "static-1.1472",
      "pulse": "static-1.340",
      "smart-property-lib": "static-1.6006",
      "tiered-pricing": "static-1.864",
      "ui-addon-form-validation": "static-1.10819",
      "video-components-external": "static-1.10632",
      "batch-promise": "static-1.1375",
      "crm-pipelines-api-client-types": "static-1.3989",
      "persist-promise": "static-1.3532",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24787",
      "knowledge-content-types": "static-1.8392",
      "payment-link-components": "static-1.23000",
      "ui-addon-emoji-picker": "static-1.9712",
      "call-summary": "static-1.38444",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9675",
      "laboratory-lib": "static-3.6984",
      "merchandise-lib": "static-1.260",
      "purchase-motions-components": "static-1.5514",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.528",
      "content-icons-ui": "static-1.2164",
      "social-insights-client-types": "static-1.21424",
      "outpost": "static-1.4029",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4631",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5419",
      "magpie-types": "static-1.4879",
      "simple-logging-lib": "static-1.2875",
      "growth-onboarding-feedback-components": "static-1.6407",
      "customer-data-sidebar": "static-2.45478",
      "enrichment-properties-lib": "static-1.15124",
      "customer-data-associations": "static-1.7164",
      "deal-intel-decorators": "static-1.1327",
      "reporting-data": "static-1.66618",
      "tanstack-virtual": "static-1.26",
      "ui-addon-draggable": "static-3.4590",
      "crm-record-cards-service-types": "static-1.3467",
      "self-service-api": "static-1.10064",
      "crm_universal": "static-1.21702",
      "SalesContentIndexUI": "static-3.8937",
      "content-embed-lib": "static-1.7165",
      "data-model-builder-lib": "static-1.11721",
      "remote-ui": "static-1.61",
      "ui-components-test-utils": "static-1.5396",
      "ui-extensions-remote-renderer": "static-1.16412",
      "universal-page-editor-lib": "static-1.2824",
      "integrations-error-boundary-lib": "static-1.12909",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10197",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45453",
      "data-token-picker": "static-1.16084",
      "sequences-client-types-lib": "static-1.7582",
      "foundations-components-test-utils": "static-1.5054",
      "navigation-messaging": "static-1.6670",
      "getting-started-shared-tasks": "static-1.17945",
      "getting-started-shared-tasks-store": "static-1.17063",
      "onboarding-tours-utils": "static-1.365",
      "messaging-usage-based-billing-components-lib": "static-1.578",
      "whatsapp-management-lib": "static-1.8144",
      "growth-data-modal": "static-1.5183",
      "growth-onboarding-confetti": "static-1.2897",
      "growth-onboarding-next-action-utils": "static-1.1348",
      "navigation-components": "static-1.17343",
      "onboarding-tours-client": "static-1.4513",
      "ui-shepherd-tracker": "static-1.7352",
      "shared-worker-versioning": "static-1.10863",
      "voice-sms-access-library": "static-1.309",
      "commerce-permissions": "static-1.584",
      "products-iframe-lib": "static-1.7388",
      "products-ui-components-shared-msw-handlers": "static-1.9911",
      "directed-graph": "static-1.764",
      "event-emitter": "static-1.772",
      "breeze-intelligence-kit": "static-1.5357",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9612",
      "fsm": "static-1.3556",
      "policy-lib": "static-1.6607",
      "react-tinymce": "static-1.54681",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53807",
      "tinymce-plugins": "static-1.56921",
      "tinymce-themes": "static-1.55777",
      "content-media-composition-data-lib": "static-1.11537",
      "content-media-compositions": "static-2.15544",
      "idb-keyval": "static-1.40",
      "media-bridge-lib": "static-1.18607",
      "ui-addon-opt": "static-4.8209",
      "commerce-tours-lib": "static-1.5755",
      "growth-onboarding-reliability": "static-1.4911",
      "sales-checkout-service-client": "static-1.3492",
      "ai-addon-copilot-preview": "static-1.7623",
      "calling-cross-tab-library": "static-1.19099",
      "calling-lifecycle-usage-tracker": "static-1.8190",
      "wootric-nps": "static-1.6809",
      "growth-monetization-service-types": "static-1.4329",
      "nav-client-types": "static-1.2182",
      "purchase-motions-api": "static-1.5517",
      "trials-service-types": "static-1.3730",
      "reactive-lib": "static-1.549",
      "card-payment-highlight-lib": "static-1.36560",
      "card-subscription-highlight-lib": "static-1.38925",
      "commerce-billing-lib": "static-1.18559",
      "commerce-contract-lib": "static-1.11272",
      "invoices-highlight-card-lib": "static-1.54099",
      "orders-highlight-card-lib": "static-1.20924",
      "products-highlight-card-lib": "static-1.17207",
      "project-storage": "static-1.4558",
      "quotes-highlight-card-lib": "static-1.71284",
      "usage-based-billing-components-lib": "static-1.8069",
      "deal-intel-utils": "static-1.1331",
      "storybook-react": "static-1.29",
      "reporting-client-types": "static-1.2387",
      "react-flip-move": "static-1.66",
      "FireAlarmUi": "static-1.4355",
      "sales-templates-service-types-lib": "static-1.4015",
      "ui-asset-management-lib": "static-1.10742",
      "association-settings-lib": "static-1.9726",
      "collaboration-sidebar": "static-1.57182",
      "conditional-property-settings-modal": "static-1.12000",
      "data-model-commons-lib": "static-1.12006",
      "feedback-loader": "static-1.28905",
      "final-form": "static-1.66",
      "html-to-image": "static-1.50",
      "object-definition-builder-lib": "static-1.6892",
      "property-management-iframe": "static-1.12423",
      "property-usages-lib": "static-1.5221",
      "reactflow": "static-1.60",
      "simple-data-table": "static-1.2244",
      "used-in-list-lib": "static-1.6747",
      "visual-association": "static-1.5675",
      "highcharts": "static-8.100",
      "reporting-visualizations": "static-1.58694",
      "ui-extensibility-client-types": "static-1.3768",
      "automation-platform-service-types": "static-1.2514",
      "ContentData": "static-1.67762",
      "email-portal-health-service-types": "static-1.801",
      "marketing-email-service-types": "static-1.1786",
      "messaging-shared-utils-lib": "static-1.27",
      "messaging-user-info-utils-lib": "static-1.197",
      "content-whatsapp-service-types": "static-1.265",
      "marketing-platform-lib": "static-1.6666",
      "short-messages-app-service-client": "static-1.3836",
      "ui-tool-access": "static-1.9970",
      "growth-onboarding-next-action-components": "static-1.1376",
      "user-context-client": "static-1.4477",
      "calling-orchestration-schema": "static-1.35086",
      "sales-views-client-types": "static-1.4111",
      "trellis-story-utils": "static-1.4345",
      "hub-http-contrib": "static-1.2867",
      "interframe": "static-3.4613",
      "tinymce-data": "static-1.39892",
      "ui-addon-sales-email": "static-1.5038",
      "codemirror": "static-5.91",
      "layout-dnd-components": "static-1.12082",
      "layout-dnd-utils": "static-1.11057",
      "react-codemirror": "static-1.10451",
      "ui-brand-identity-lib": "static-1.14024",
      "NamespacedHubStyle": "static-2.8920",
      "hls.js": "static-1.35",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9370",
      "ai-settings-ui-library": "static-1.7534",
      "copilot-plugins": "static-1.10564",
      "eligibility-engine-service-types": "static-1.3011",
      "commerce-shared-components-lib": "static-1.18007",
      "commerce-subscription-lib": "static-1.36502",
      "commerce-tools-ui-lib": "static-1.9853",
      "usage-tracker-session-replay": "static-1.4846",
      "utility-belt": "static-1.2365",
      "payments-enrollment-embed-lib": "static-1.22083",
      "products-ui-components": "static-1.39442",
      "quotes-ui-lib": "static-1.80004",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6762",
      "invoices-ui-lib": "static-1.54115",
      "commerce-products-api": "static-1.1990",
      "SafeStorage": "static-1.4228",
      "invoices-iframe-lib": "static-1.56173",
      "quotes-modal-lib": "static-1.101961",
      "platform-infra-nav-components": "static-1.7515",
      "reporting-ui-components": "static-2.63889",
      "subscription-experience-data-types": "static-1.14613",
      "association-translator": "static-1.3014",
      "crm-settings-header-lib": "static-1.8143",
      "settings-ui-nav": "static-2.10007",
      "chatspot-widget-iframe": "static-1.20415",
      "collaboration-sidebar-common": "static-1.1979",
      "crm-properties-common-lib": "static-1.5696",
      "ui-addon-draggable-compat": "static-2.4078",
      "property-management-common": "static-1.4710",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14852",
      "advanced-menus-lib": "static-1.11823",
      "ExportDialog": "static-6.10211",
      "ui-memberships-settings-lib": "static-1.33504",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9382",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13623",
      "highlight.js": "static-1.75",
      "reporting-action-components": "static-1.40714",
      "reporting-snowflake": "static-1.55236",
      "ui-addon-react-router-dom": "static-1.9370",
      "growth-onboarding-empty-states": "static-1.5401",
      "InboxConnectUtils": "static-4.14283",
      "payments-post-enroll-local-storage-lib": "static-1.4938",
      "qrcode-generator": "static-1.65",
      "amplitude-session-replay-browser": "static-1.56",
      "marketplace-ui-apps-core": "static-1.17544",
      "stripe-embedded-components": "static-1.7175",
      "commerce-tax-lib": "static-1.341",
      "property-description-translator": "static-1.3681",
      "commerce-analytics-service-client": "static-1.3480",
      "totals-ui-components": "static-1.23054",
      "reporting-plugins": "static-1.10016",
      "reporting-reports": "static-1.66296",
      "edison-service-client-types": "static-1.217",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14851",
      "simple-menus-lib": "static-1.16368",
      "academy-common-lib": "static-1.13083",
      "dashboard-lib": "static-1.80714",
      "share-with-third-party-component-lib": "static-1.8518",
      "developer-experience-shared-components": "static-1.10315",
      "marketplace-ui-client-types": "static-1.16418",
      "marketplace-ui-common": "static-1.19011",
      "ui-addon-integrations-directory-panel": "static-2.7815",
      "stripe-connect-js": "static-1.65",
      "commerce-totals-service-types": "static-1.3663",
      "campaign-roi-lib": "static-1.8342",
      "academy-service-client": "static-1.3504",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3702",
      "oauth-service-types": "static-1.4071",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28394",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9501",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4543",
      "atom": "/atom/static-1.4894",
      "conversations-async-data": "/conversations-async-data/static-2.7488",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8701",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15790",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12527",
      "conversations-message-history": "/conversations-message-history/static-1.12100",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10323",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21757",
      "head-dlb": "/head-dlb/static-1.4841",
      "hs-promise-utils": "/hs-promise-utils/static-1.5418",
      "hs-test-utils": "/hs-test-utils/static-1.7831",
      "hubspot-dlb": "/hubspot-dlb/static-2.1806",
      "HubStyleTokens": "/HubStyleTokens/static-2.11258",
      "I18n": "/I18n/static-7.1577",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2842",
      "jasmine-runner": "/jasmine-runner/static-1.6296",
      "quartz": "/quartz/static-1.6767",
      "react-dlb": "/react-dlb/static-1.73",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.61",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4299",
      "StyleGuideUI": "/StyleGuideUI/static-3.484",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4356",
      "usage-tracker": "/usage-tracker/static-1.7160",
      "usage-tracker-core": "/usage-tracker-core/static-1.7010",
      "usage-tracker-public": "/usage-tracker-public/static-1.6971",
      "viral-links-lib": "/viral-links-lib/static-1.6861",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5959",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4634",
      "conversations-prop-types": "/conversations-prop-types/static-1.7277",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20494",
      "cssUtils": "/cssUtils/static-1.741",
      "enviro": "/enviro/static-4.405",
      "flux-actions": "/flux-actions/static-1.310",
      "foundations-components": "/foundations-components/static-1.7571",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6044",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9436",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.367",
      "raven": "/raven/static-3.5725",
      "react": "/react/static-7.180",
      "react-aria": "/react-aria/static-1.62",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.67",
      "react-rhumb": "/react-rhumb/static-1.16476",
      "react-utils": "/react-utils/static-2.5198",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7969",
      "signup-constants": "/signup-constants/static-1.18469",
      "styled-components": "/styled-components/static-2.85",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5574",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5770",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
      "raven-hubspot": "/raven-hubspot/static-1.6032",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3252",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.78",
      "quartz-config": "/quartz-config/static-1.545",
      "quartz-core": "/quartz-core/static-1.5986",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4661",
      "foundations-theming": "/foundations-theming/static-1.4237",
      "UIComponents": "/UIComponents/static-3.8205",
      "customer-data-email": "/customer-data-email/static-1.17712",
      "cv-backend-services": "/cv-backend-services/static-1.1513",
      "immutable-less": "/immutable-less/static-1.4479",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7073",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32547",
      "customer-data-objects": "/customer-data-objects/static-1.7473",
      "icons": "/icons/static-2.623",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4459",
      "ui-images": "/ui-images/static-2.1101",
      "HeadJS": "/HeadJS/static-2.715",
      "framer-motion": "/framer-motion/static-1.68",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2942",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.148",
      "i18n-data": "/i18n-data/static-1.217",
      "moment-timezone": "/moment-timezone/static-5.79",
      "jasmine": "/jasmine/static-4.4151",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
      "HubStyle": "/HubStyle/static-2.11566",
      "quartz-i18n": "/quartz-i18n/static-1.442",
      "sassPrefix": "/sassPrefix/static-1.152",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3840",
      "floating-ui": "/floating-ui/static-1.52",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1953",
      "hs-story-utils": "/hs-story-utils/static-1.9251",
      "react-virtualized": "/react-virtualized/static-2.95",
      "tanstack-table": "/tanstack-table/static-1.51",
      "trellis-assets": "/trellis-assets/static-1.1286",
      "ui-fonts": "/ui-fonts/static-1.520",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3760",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5577",
      "bender-build-tools": "/bender-build-tools/static-1.2970",
      "dispatcher": "/dispatcher/static-1.132",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.799",
      "hubspotter-http": "/hubspotter-http/static-1.4501",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.488",
      "module-federation": "/module-federation/static-1.19",
      "quartz-auth": "/quartz-auth/static-1.442",
      "quartz-head": "/quartz-head/static-1.432",
      "quartz-routing": "/quartz-routing/static-1.197",
      "quartz-test": "/quartz-test/static-1.442",
      "quartz-tracking": "/quartz-tracking/static-1.146",
      "usage-tracker-container": "/usage-tracker-container/static-1.7150",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2720",
      "foundations-theming-base": "/foundations-theming-base/static-1.3222",
      "stylex": "/stylex/static-1.28",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4476",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9648",
      "FileManagerCore": "/FileManagerCore/static-1.38469",
      "FileManagerLib": "/FileManagerLib/static-1.38610",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4705",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.521",
      "timezone-utils": "/timezone-utils/static-2.5069",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10172",
      "ts-schema": "/ts-schema/static-1.3928",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8411",
      "avatar-components": "/avatar-components/static-1.2313",
      "content-assistance-lib": "/content-assistance-lib/static-1.7484",
      "crm-component-utils": "/crm-component-utils/static-1.38526",
      "crm-display-components": "/crm-display-components/static-1.24276",
      "crm-fe-perf": "/crm-fe-perf/static-1.22730",
      "crm-links": "/crm-links/static-1.6091",
      "crm-message-bus": "/crm-message-bus/static-1.42427",
      "crm-search-service-types": "/crm-search-service-types/static-1.978",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5154",
      "customer-data-communicator": "/customer-data-communicator/static-1.44980",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38982",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12833",
      "customer-data-properties": "/customer-data-properties/static-1.50858",
      "customer-data-rte": "/customer-data-rte/static-1.32500",
      "draft-plugins": "/draft-plugins/static-2.21349",
      "file-manager-components": "/file-manager-components/static-1.22970",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6697",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7749",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17665",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10139",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7919",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17692",
      "universal-associations-select": "/universal-associations-select/static-1.10815",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3698",
      "property-translator": "/property-translator/static-1.5235",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9529",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9527",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-dnd-compat": "/react-dnd-compat/static-1.4445",
      "audio-components": "/audio-components/static-1.5647",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.36121",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.596",
      "immerable": "/immerable/static-1.3979",
      "ui-universal-auth": "/ui-universal-auth/static-1.8733",
      "video-components": "/video-components/static-1.12635",
      "video-data-lib": "/video-data-lib/static-1.34290",
      "video-embed": "/video-embed/static-1.35124",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.164",
      "chatspot-core": "/chatspot-core/static-1.20423",
      "chirp-fetch": "/chirp-fetch/static-1.1707",
      "ContentUtils": "/ContentUtils/static-1.67687",
      "copilot-toolkit": "/copilot-toolkit/static-1.10591",
      "superstore": "/superstore/static-1.4595",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8521",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28001",
      "card-properties-lib": "/card-properties-lib/static-1.43586",
      "crm-actions": "/crm-actions/static-1.6130",
      "crm-cards-data": "/crm-cards-data/static-1.1261",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42985",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8856",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7904",
      "customer-data-tracking": "/customer-data-tracking/static-1.6706",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3444",
      "framework-data-table": "/framework-data-table/static-2.11468",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8630",
      "calling-error-reporting": "/calling-error-reporting/static-1.31125",
      "calling-internal-common": "/calling-internal-common/static-1.31119",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6365",
      "crm_data": "/crm_data/static-4.91293",
      "customer-data-content": "/customer-data-content/static-1.26916",
      "draft-content-plugins": "/draft-content-plugins/static-1.27767",
      "draft-convert": "/draft-convert/static-2.68",
      "draft-extend": "/draft-extend/static-3.71",
      "draft-js": "/draft-js/static-5.73",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23569",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23960",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17657",
      "integration-settings-components": "/integration-settings-components/static-1.14865",
      "integrations-lib": "/integrations-lib/static-1.15494",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5413",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7613",
      "nav-meta": "/nav-meta/static-1.28980",
      "onboarding-scopes": "/onboarding-scopes/static-1.6287",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5822",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37373",
      "react-colorpicker": "/react-colorpicker/static-2.10035",
      "reference-resolvers": "/reference-resolvers/static-1.7986",
      "rich-text-lib": "/rich-text-lib/static-1.19513",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3668",
      "sequences-lib": "/sequences-lib/static-1.7725",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10968",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8871",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8854",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9971",
      "user-context": "/user-context/static-1.4924",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4985",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21417",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12971",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4552",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3857",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6602",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.798",
      "onboarding-tours": "/onboarding-tours/static-1.16299",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13123",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "ui-addon-teams": "/ui-addon-teams/static-1.21274",
      "calling-global-api": "/calling-global-api/static-1.63753",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65135",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57429",
      "commerce-products-lib": "/commerce-products-lib/static-1.8923",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3647",
      "external-options-client-types": "/external-options-client-types/static-1.4008",
      "google-libphonenumber": "/google-libphonenumber/static-1.34",
      "hs-entities": "/hs-entities/static-1.504",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4071",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.457",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3540",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48065",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3812",
      "property-value-citations": "/property-value-citations/static-1.1472",
      "pulse": "/pulse/static-1.340",
      "smart-property-lib": "/smart-property-lib/static-1.6006",
      "tiered-pricing": "/tiered-pricing/static-1.864",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10819",
      "video-components-external": "/video-components-external/static-1.10632",
      "batch-promise": "/batch-promise/static-1.1375",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3989",
      "persist-promise": "/persist-promise/static-1.3532",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24787",
      "knowledge-content-types": "/knowledge-content-types/static-1.8392",
      "payment-link-components": "/payment-link-components/static-1.23000",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9712",
      "call-summary": "/call-summary/static-1.38444",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9675",
      "laboratory-lib": "/laboratory-lib/static-3.6984",
      "merchandise-lib": "/merchandise-lib/static-1.260",
      "purchase-motions-components": "/purchase-motions-components/static-1.5514",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.528",
      "content-icons-ui": "/content-icons-ui/static-1.2164",
      "social-insights-client-types": "/social-insights-client-types/static-1.21424",
      "outpost": "/outpost/static-1.4029",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4631",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5419",
      "magpie-types": "/magpie-types/static-1.4879",
      "simple-logging-lib": "/simple-logging-lib/static-1.2875",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6407",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45478",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15124",
      "customer-data-associations": "/customer-data-associations/static-1.7164",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1327",
      "reporting-data": "/reporting-data/static-1.66618",
      "tanstack-virtual": "/tanstack-virtual/static-1.26",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4590",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3467",
      "self-service-api": "/self-service-api/static-1.10064",
      "crm_universal": "/crm_universal/static-1.21702",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8937",
      "content-embed-lib": "/content-embed-lib/static-1.7165",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11721",
      "remote-ui": "/remote-ui/static-1.61",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5396",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16412",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2824",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12909",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10197",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45453",
      "data-token-picker": "/data-token-picker/static-1.16084",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7582",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5054",
      "navigation-messaging": "/navigation-messaging/static-1.6670",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17945",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17063",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.365",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.578",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8144",
      "growth-data-modal": "/growth-data-modal/static-1.5183",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2897",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1348",
      "navigation-components": "/navigation-components/static-1.17343",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4513",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7352",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10863",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.309",
      "commerce-permissions": "/commerce-permissions/static-1.584",
      "products-iframe-lib": "/products-iframe-lib/static-1.7388",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9911",
      "directed-graph": "/directed-graph/static-1.764",
      "event-emitter": "/event-emitter/static-1.772",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5357",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9612",
      "fsm": "/fsm/static-1.3556",
      "policy-lib": "/policy-lib/static-1.6607",
      "react-tinymce": "/react-tinymce/static-1.54681",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53807",
      "tinymce-plugins": "/tinymce-plugins/static-1.56921",
      "tinymce-themes": "/tinymce-themes/static-1.55777",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11537",
      "content-media-compositions": "/content-media-compositions/static-2.15544",
      "idb-keyval": "/idb-keyval/static-1.40",
      "media-bridge-lib": "/media-bridge-lib/static-1.18607",
      "ui-addon-opt": "/ui-addon-opt/static-4.8209",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5755",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4911",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3492",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7623",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19099",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8190",
      "wootric-nps": "/wootric-nps/static-1.6809",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
      "nav-client-types": "/nav-client-types/static-1.2182",
      "purchase-motions-api": "/purchase-motions-api/static-1.5517",
      "trials-service-types": "/trials-service-types/static-1.3730",
      "reactive-lib": "/reactive-lib/static-1.549",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36560",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38925",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18559",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11272",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54099",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20924",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17207",
      "project-storage": "/project-storage/static-1.4558",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71284",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8069",
      "deal-intel-utils": "/deal-intel-utils/static-1.1331",
      "storybook-react": "/storybook-react/static-1.29",
      "reporting-client-types": "/reporting-client-types/static-1.2387",
      "react-flip-move": "/react-flip-move/static-1.66",
      "FireAlarmUi": "/FireAlarmUi/static-1.4355",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4015",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10742",
      "association-settings-lib": "/association-settings-lib/static-1.9726",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57182",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12000",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12006",
      "feedback-loader": "/feedback-loader/static-1.28905",
      "final-form": "/final-form/static-1.66",
      "html-to-image": "/html-to-image/static-1.50",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6892",
      "property-management-iframe": "/property-management-iframe/static-1.12423",
      "property-usages-lib": "/property-usages-lib/static-1.5221",
      "reactflow": "/reactflow/static-1.60",
      "simple-data-table": "/simple-data-table/static-1.2244",
      "used-in-list-lib": "/used-in-list-lib/static-1.6747",
      "visual-association": "/visual-association/static-1.5675",
      "highcharts": "/highcharts/static-8.100",
      "reporting-visualizations": "/reporting-visualizations/static-1.58694",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3768",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2514",
      "ContentData": "/ContentData/static-1.67762",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.801",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1786",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.27",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.197",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.265",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6666",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3836",
      "ui-tool-access": "/ui-tool-access/static-1.9970",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1376",
      "user-context-client": "/user-context-client/static-1.4477",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35086",
      "sales-views-client-types": "/sales-views-client-types/static-1.4111",
      "trellis-story-utils": "/trellis-story-utils/static-1.4345",
      "hub-http-contrib": "/hub-http-contrib/static-1.2867",
      "interframe": "/interframe/static-3.4613",
      "tinymce-data": "/tinymce-data/static-1.39892",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5038",
      "codemirror": "/codemirror/static-5.91",
      "layout-dnd-components": "/layout-dnd-components/static-1.12082",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11057",
      "react-codemirror": "/react-codemirror/static-1.10451",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14024",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8920",
      "hls.js": "/hls.js/static-1.35",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9370",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7534",
      "copilot-plugins": "/copilot-plugins/static-1.10564",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18007",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36502",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9853",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4846",
      "utility-belt": "/utility-belt/static-1.2365",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22083",
      "products-ui-components": "/products-ui-components/static-1.39442",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80004",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6762",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54115",
      "commerce-products-api": "/commerce-products-api/static-1.1990",
      "SafeStorage": "/SafeStorage/static-1.4228",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56173",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101961",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7515",
      "reporting-ui-components": "/reporting-ui-components/static-2.63889",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14613",
      "association-translator": "/association-translator/static-1.3014",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8143",
      "settings-ui-nav": "/settings-ui-nav/static-2.10007",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20415",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1979",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5696",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4078",
      "property-management-common": "/property-management-common/static-1.4710",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14852",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11823",
      "ExportDialog": "/ExportDialog/static-6.10211",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33504",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9382",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13623",
      "highlight.js": "/highlight.js/static-1.75",
      "reporting-action-components": "/reporting-action-components/static-1.40714",
      "reporting-snowflake": "/reporting-snowflake/static-1.55236",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9370",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5401",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14283",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4938",
      "qrcode-generator": "/qrcode-generator/static-1.65",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17544",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7175",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.341",
      "property-description-translator": "/property-description-translator/static-1.3681",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3480",
      "totals-ui-components": "/totals-ui-components/static-1.23054",
      "reporting-plugins": "/reporting-plugins/static-1.10016",
      "reporting-reports": "/reporting-reports/static-1.66296",
      "edison-service-client-types": "/edison-service-client-types/static-1.217",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14851",
      "simple-menus-lib": "/simple-menus-lib/static-1.16368",
      "academy-common-lib": "/academy-common-lib/static-1.13083",
      "dashboard-lib": "/dashboard-lib/static-1.80714",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8518",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10315",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16418",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19011",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7815",
      "stripe-connect-js": "/stripe-connect-js/static-1.65",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3663",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8342",
      "academy-service-client": "/academy-service-client/static-1.3504",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3702",
      "oauth-service-types": "/oauth-service-types/static-1.4071",
      "react-window": "/react-window/static-1.13"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28394",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};